'use client';
import React from 'react';

import { CustomLink } from './custom-link';

import { IconBrandDiscord, IconBrandX } from '@tabler/icons-react';
import { Logo } from './logo';
import { ThemeToggle } from '../theme-toggle';
import Link from 'next/link';

export const Footer = () => {
  const pages = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Pricing',
      link: '/pricing',
    },
    {
      name: 'Models',
      link: '/models',
    },
    {
      name: 'Docs',
      link: 'https://readme.fireworks.ai/docs',
    },
  ];
  const company = [
    {
      name: 'Blog',
      link: '/blog',
    },
    {
      name: 'Careers',
      link: 'https://jobs.polymer.co/fireworks-ai',
    },
    // {
    //   name: 'Team',
    //   link: '/team',
    // },
  ];

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-wrap justify-between gap-10 px-8 py-20">
      <div className="flex flex-col">
        <div className="flex flex-col">
          <Link href="/" className="cursor-pointer">
            <Logo SVGAttributes={{ role: 'graphics-symbol', 'aria-label': 'Fireworks AI Home' }} />
          </Link>
        </div>
        <p className="my-4 text-left text-sm font-normal text-slate-500">
          © {new Date().getFullYear()} Fireworks AI All rights reserved.
        </p>

        <div className="mb-8 flex items-center space-x-2 text-left text-sm font-light text-slate-500">
          <a
            href="https://discord.gg/fireworks-ai"
            target="__blank"
            title="Join our Discord for questions and support"
            aria-label="Join the Fireworks.ai discord (Link opens in a new tab)"
          >
            <IconBrandDiscord role="img" aria-hidden="true" className="h-6 w-6" />
          </a>

          <a
            href="https://twitter.com/FireworksAI_HQ"
            target="__blank"
            title="Follow us on X for the latest updates"
            aria-label="Follow Fireworks.ai on X (Link opens in a new tab)"
          >
            <IconBrandX role="img" aria-hidden="true" className="h-6 w-6" />
          </a>
        </div>
        <div>
          <ThemeToggle />
        </div>
      </div>
      <div className="flex gap-10">
        <div className="flex flex-col gap-2">
          <p className="mb-2 font-bold">Pages</p>
          {pages.map((item) => (
            <CustomLink href={item.link} key={item.link} className="hover:text-primary">
              {item.name}
            </CustomLink>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <p className="mb-2 font-bold">Company</p>
          {company.map((item) => (
            <CustomLink href={item.link} key={item.link} className="hover:text-primary">
              {item.name}
            </CustomLink>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <p className="mb-2 font-bold">Legal</p>
          <CustomLink href="/terms-of-service">Terms of Service</CustomLink>
          <CustomLink href="/privacy-policy">Privacy Policy</CustomLink>
        </div>
      </div>
    </div>
  );
};
